/**
 *
 * Asynchronously loads the component for WhatsNew
 *
 */

import { loadable } from '../../../utils';

export default loadable(() => import('./index'), {});
